import React from 'react'
import './style.css'

export default (props) =>{
    return(
        <div className='empreendimento_wrapper'>
            <center style={{margin:'100px'}}>Em construção</center>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/views/website/empreendimento/component.js